const formatNumber = n => {
  n = n.toString();
  return n[1] ? n : "0" + n;
};
// 日期格式化
export function formatTimeYTD(time, str) {
  // 获得当前运行环境时间
  const d = new Date(time);
  const currentDate = new Date(time);
  const tmpHours = currentDate.getHours();
  // 算得时区
  let timeZone = -d.getTimezoneOffset() / 60;
  // 少于0的是西区 西区应该用时区绝对值加京八区 重新设置时间（西区时间比东区时间早 所以加时区间隔）
  if (timeZone < 0) {
    timeZone = Math.abs(timeZone) + 8;
    currentDate.setHours(tmpHours + timeZone);
  } else {
    // 大于0的是东区  东区时间直接跟京八区相减
    timeZone -= 8;
    currentDate.setHours(tmpHours - timeZone);
  }
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const day = currentDate.getDate();
  if (str === "time") {
    return currentDate;
  } else {
    return `${formatNumber(year)}${str || "-"}${formatNumber(month)}${str ||
      "-"}${formatNumber(day)}`;
  }
}
// 日期格式化
export function formatTime(number, format) {
  if (typeof number === "undefined") {
    return "";
  }
  var formateArr = ["Y", "M", "D", "h", "m", "s"];
  var returnArr = [];
  // 如果number是1995-05-15或者1995.05-15，转化为1995/05/15
  if (typeof(number) !== 'number' && !/^\d+$/.test(number)) {
    number = number.replace(/-|\./g, '/')
  }
  var date = new Date(number);
  date = new Date(formatTimeYTD(date, 'time'))
  returnArr.push(date.getFullYear());  
  returnArr.push(formatNumber(date.getMonth() + 1));  
  returnArr.push(formatNumber(date.getDate()));  
  returnArr.push(formatNumber(date.getHours()));  
  returnArr.push(formatNumber(date.getMinutes()));  
  returnArr.push(formatNumber(date.getSeconds()));  
  
  for (var i in returnArr)
  {  
    format = format.replace(formateArr[i], returnArr[i]);  
  }  
  return format; 
} 
// 手机号
export function checkPhone(str) {
  str = str + "";
  var reg = /^[1]([0-9])[0-9]{9}$/;
  return reg.test(str);
}

// 手机号固定格式显示xxx****xxxx
export function formatPhone(phone) {
  phone = "" + phone;
  return phone.substr(0, 3) + "****" + phone.substr(7, 11);
}

// 将秒转化为对应的分秒
export function secToTime(v) {
  const s = parseInt(v);
  let t = "";
  if (s >= 0) {
    const min = Math.floor(s / 60) % 60;
    const sec = s % 60;
    if (min < 10) {
      t += "0";
    }
    // t += min + "分";
    t += min + ":";
    if (sec < 10) {
      t += "0";
    }
    // t += sec.toFixed(0)+"秒";
    t += sec.toFixed(0);
  }
  return t;
}

// 将秒转化为对应的天时分秒
export function activityTime(v) {
  const s = parseInt(v);
  let t = "";
  if (s >= 0) {
    const day = Math.floor(s / (60 * 60 * 24)).toFixed(0);
    const hour = Math.floor((s - 60 * 60 * 24 * day) / 3600).toFixed(0);
    const min = Math.floor((s - 60 * 60 * 24 * day - 3600 * hour) / 60).toFixed(
      0
    );
    const sec = Math.floor(
      s - 60 * 60 * 24 * day - 3600 * hour - 60 * min
    ).toFixed(0);
    t = day + "天" + hour + "时" + min + "分" + sec + "秒";
  }
  return t;
}

export function getSearchString(key) {
  let str = location.search;
  str = str.substring(1, str.length);
  const arr = str.split("&");
  const obj = {};
  for (let i = 0; i < arr.length; i++) {
    const tmpArr = arr[i].split("=");
    obj[decodeURIComponent(tmpArr[0])] = decodeURIComponent(tmpArr[1]);
  }
  return obj[key];
}

// 将某个字符串的某些位置的字符更改 source原字符串 pos位置 newChar新字符   arr: [{ pos: 2, newChar: 0}, { pos: 8, newChar: 1}]
export function replaceChat(source, arr) {
  let str = source;
  const iBeginPos = 0;
  arr.forEach(item => {
    const sFrontPart = str.substr(iBeginPos, Number(item.pos));
    const sTailPart = source.substr(Number(item.pos) + 1, str.length);
    str = sFrontPart + item.newChar + sTailPart;
  });
  return str;
}

// 判断一个值的某属性与给定值相等的值在该数组中出现了几次
export function countOccurences(arr, value, key) {
  return arr.reduce((prev, cur) => {
    return cur[key] === value ? prev + 1 : prev + 0;
  }, 0);
}

// 将某过长的字符串截取为指定长度
export function stringSlice(str = "", num = 0) {
  if (str.length <= num) {
    return str;
  }
  const newStr = str.slice(0, num);
  return newStr + "...";
}

/**
 ** 减法函数，用来得到精确的减法结果
 ** 说明：javascript的减法结果会有误差，在两个浮点数相减的时候会比较明显。这个函数返回较为精确的减法结果。
 ** 调用：accSub(arg1,arg2)
 ** 返回值：arg1加上arg2的精确结果
 **/
export function accSub(arg1, arg2) {
  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
  n = r1 >= r2 ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

/**
 ** 加法函数，用来得到精确的加法结果
 ** 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
 ** 调用：accAdd(arg1,arg2)
 ** 返回值：arg1加上arg2的精确结果
 **/
export function accAdd(arg1, arg2) {
  var r1, r2, m, c;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  c = Math.abs(r1 - r2);
  m = Math.pow(10, Math.max(r1, r2));
  if (c > 0) {
    var cm = Math.pow(10, c);
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace(".", ""));
      arg2 = Number(arg2.toString().replace(".", "")) * cm;
    } else {
      arg1 = Number(arg1.toString().replace(".", "")) * cm;
      arg2 = Number(arg2.toString().replace(".", ""));
    }
  } else {
    arg1 = Number(arg1.toString().replace(".", ""));
    arg2 = Number(arg2.toString().replace(".", ""));
  }
  return (arg1 + arg2) / m;
}

// 计算出星座
export function constellationFn(month, day) {
  if (!/\d/.test(month) || !/\d/.test(day)){
    return
  }
  month = Number(month);
  day = Number(day);
  var dayArr = [20, 19, 21, 20, 21, 22, 23, 23, 23, 24, 23, 22];
  var constellationArr = [
    "摩羯座",
    "水瓶座",
    "双鱼座",
    "白羊座",
    "金牛座",
    "双子座",
    "巨蟹座",
    "狮子座",
    "处女座",
    "天秤座",
    "天蝎座",
    "射手座",
    "摩羯座"
  ];
  var constellationStr =
    day < dayArr[month - 1]
      ? constellationArr[month - 1]
      : constellationArr[month];
  return constellationStr;
}

// 计算某一日期
export function getDay(date) {
  //const arr = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
  const arr = ["Sun", "Mon", "Tues", "Wed", "Thur", "Fri", "Sat"];
  const index = new Date(date).getDay();

  // 获取今天的日期
  const dateStart = new Date(
    new Date().toLocaleDateString() + " 00:00:00"
  ).getTime();
  const dateEnd = new Date(date).getTime();
  const difValue = (dateEnd - dateStart) / (1000 * 60 * 60 * 24);
  if (difValue < 0) {
    // date 是今天之前的时间
    return arr[index];
  } else if (difValue >= 0 && difValue < 1) {
    return "today";
  } else if (difValue >= 1 && difValue < 2) {
    return "tomorrow";
  } else {
    return arr[index];
  }
}

// 每4个字符串空一格，如1234 ad25 21
export function setFourStrOneBlank(str) {
  return str.replace(/(.{4})/g, "$1 ");
}

// 验证字符串中是否包含字符或数字
export function checkLetterNum(str) {
  return /^[0-9A-Za-z]+$/g.test(str)
}

// 将数字转化为小数加00 如100转化为100.00
export function changeTwoDecimal_f(x)  
{  
　　var f_x = parseFloat(x);  
　　if (isNaN(f_x))  
　　{  
　　　　return 0;  
　　}  
　　var f_x = Math.round(x*100)/100;  
　　var s_x = f_x.toString();  
　　var pos_decimal = s_x.indexOf('.');  
　　if (pos_decimal < 0)  
　　{  
　　　　pos_decimal = s_x.length;  
　　s_x += '.';  
　　}  
　　while (s_x.length <= pos_decimal + 2)  
　　{  
　　　　s_x += '0';  
　　}  
　　return s_x;  
}

// 获取url参数
export function getUrlKey (name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

// 设置cookie
export function setCookie(cname,cvalue,exdays)
{
  var d = new Date();
  d.setTime(d.getTime()+(exdays*24*60*60*1000));
  var expires = "expires="+d.toGMTString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}

// 获取cookie
export function getCookie(cname)
{
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) 
  {
    var c = ca[i].trim();
    if (c.indexOf(name)==0) return c.substring(name.length,c.length);
  }
  return "";
}

export function getCookieuUne(name)  //解码cookie
{
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (arr = document.cookie.match(reg))
                return unescape(arr[2]);
            else
                return "null";
}


// WEBPACK FOOTER //
// ./src/utils/util.js